import React, { useCallback, useEffect, useLayoutEffect } from "react";
import { Route, useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { notification } from "antd";

import { settingInformationDataResponse } from "redux/setting/general/generalSettingStates";

import { isLoggedIn, localStorageHelper, removeCookie, setCookie } from "utils";
import { IRoute } from "routes/configs";
import { SettingInformationActionCreators } from "redux/rootActions";
import { authTokenKey } from "configs/httpClient";

export interface IRestrictedRouteProps extends IRoute {
  isPrivate?: boolean;
  from?: string;
}

const RestrictedRoute: React.FC<IRestrictedRouteProps> = ({
  children,
  restricted = false,
  isPrivate,
  layout: Layout,
  from,
  ...props
}) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const accountRole = localStorageHelper.getItem("role");

  const settingInformationData = useSelector(settingInformationDataResponse);

  useEffect(() => {
    notification.destroy();
  }, [location]);

  const redirect = useCallback(() => {
    const currentPathName = window.location.pathname;
    const convertPathname = "/" + window.location.href.split("/")[3];

    const commonURL = [
      "/personalregistration/SII",
      "/verify-phone-number",
      "/account-registration",
      "/verify-otp",
      "/download-app-qr",
    ];
    const publicURL = [
      "/login",
      "/forgot-password",
      "/forgot-password-notification",
      "/reset-password",
      "/reset-password-notification",
      ...commonURL,
    ];

    const privateURL = [
      "/education-consultation-list",
      "/settings",
      "/dashboard",
      "/message-delivery",
      "/resources-download",
      "/change-password",
      "/message-delivery/history",
      ...commonURL,
    ];
    const restrictedUrl: any[] = [];

    if (settingInformationData?.result) {
      if (!settingInformationData?.result?.is_able_consultation_nav) {
        restrictedUrl.push("/education-consultation-list");
      }
    }

    const params = new URLSearchParams(window.location.search);
    const auth_token = params.get("token");

    if (auth_token) {
      removeCookie(authTokenKey);
      window.localStorage.clear();
    }

    if (!isLoggedIn()) {
      if (publicURL.includes(currentPathName)) {
        const name = params.get("name");

        if (auth_token) {
          setCookie(authTokenKey, auth_token);
          localStorageHelper.setItem("supercity_name", name + "管理画面");
          history.replace("/user-list");
        } else {
          if (from !== "sub") {
            if (currentPathName !== "/reset-password") {
              history.replace(currentPathName);
            }
          }
        }
      } else {
        history.replace("/login");
      }
    }

    if (isPrivate && !isLoggedIn()) {
      if (!publicURL.includes(currentPathName)) {
        history.replace("/login");
      }
    }

    if (restricted && isLoggedIn()) {
      if (!privateURL.includes(currentPathName) || currentPathName === "/") {
        history.replace("/user-list");
      }
      if (restrictedUrl.length && restrictedUrl.includes(currentPathName)) {
        history.replace("/user-list");
      }
    }
  }, [isPrivate, history, restricted, settingInformationData]);

  useEffect(() => {
    if (isPrivate && isLoggedIn()) {
      dispatch(SettingInformationActionCreators.getSettingInformationAction());
    }
  }, [isPrivate]);

  useLayoutEffect(() => {
    redirect();
  }, [redirect, location.pathname]);

  // const Component = Layout ? <Layout>{children}</Layout> : children;

  return <Route {...props}>{children}</Route>;
};

export default RestrictedRoute;
